import React from 'react'
import PropTypes from 'prop-types'
import { Form, Formik } from 'formik'
import TimeUtil from 'utils/time-util'
import consignmentInboundRequestConfirmFormSchema from 'domains/consignment-inbound-request/confirm-form/consignment-inbound-request-confirm-form-schema'
import { InputField, InputSelectOptions, LoaderButton } from 'components/molecules'
import { PICKUP_VEHICLE_TYPES } from 'domains/seller-inbound/constants'
import { SHIPPING_METHOD } from 'domains/consignment-inbound-request/constants'

const propTypes = {
  consignmentInboundRequest : PropTypes.object,
  onSubmit                  : PropTypes.func
}

const defaultProps = {
  consignmentInboundRequest : {},
  onSubmit                  : () => {}
}


const ConsignmentInboundRequestConfirmForm = ({
  consignmentInboundRequest,
  onSubmit
}) =>
{
  const isPickup = consignmentInboundRequest.shipping_method == SHIPPING_METHOD.PICKUP
  return (
    <Formik
      enableReinitialize={ true }
      initialValues={{
        shipping_method     : consignmentInboundRequest?.shipping_method || '',
        pickup_vehicle_type : consignmentInboundRequest?.pickup_vehicle_type || '',
        scheduled_at        : consignmentInboundRequest?.scheduled_at ? TimeUtil.format(consignmentInboundRequest?.scheduled_at, 'YYYY-MM-DD') : ''
      }}
      validationSchema={ consignmentInboundRequestConfirmFormSchema }
      onSubmit={ onSubmit }
    >
      <Form>
        {
          isPickup
          && (
            <InputField
              type='select'
              label="Kendaraan Pickup"
              name='pickup_vehicle_type'
              required={ true }
            >
              <InputSelectOptions options={ PICKUP_VEHICLE_TYPES } keyPrefix={ 'is_auto_discount' } />
            </InputField>
          )
        }

        <InputField
          type='date'
          name='scheduled_at'
          label='Scheduled At'
          required={ true }
        />
        <LoaderButton
          color='primary'
          className='text-uppercase float-right wider'
          type='submit'
          text='Confirm'
        />
      </Form>
    </Formik>
  )
}
ConsignmentInboundRequestConfirmForm.propTypes    = propTypes
ConsignmentInboundRequestConfirmForm.defaultProps = defaultProps

export default ConsignmentInboundRequestConfirmForm